import styled from 'styled-components'
import globals from '../globals'


export const CustomAlert = styled.div`
  display: ${props => props.visible ? 'block' : 'none'};
  color: white;
  border-radius: 4px;
  font-weight: bold;
  padding:${props => props.visible ? '10px' : '0'};
  transition: all .2s;
  overflow: hidden;
  background: ${props => props.type === 'success' ? globals.colors.green : globals.colors.red}
`